import { createContext, useContext } from 'react';

export type EnterprisePermittedProductsContextType = {
  loading?: boolean;
  isProgramLimitedContent?: boolean;
};

export const EnterprisePermittedProductsContext = createContext<EnterprisePermittedProductsContextType | undefined>(
  undefined
);

export const useEnterprisePermittedProducts = () => useContext(EnterprisePermittedProductsContext);

export default EnterprisePermittedProductsContext;
